'use client';
import React, { useState, useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';

let signalstopic = 'goldensparrowcapital-signals';

const PreSignalsComponent = props => {

  const [preSignals, setPreSignals] = useState([])
  const [section, setSection] = useState('Active');
  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // this will prevent receving the subscribed message multiple times
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [popupPreSignal, setPopupPreSignal] = useState(null);
const [fvgLow, setFvgLow] = useState({}); // { [uuid]: value }
const [fvgHigh, setFvgHigh] = useState({}); // { [uuid]: value }

  //connect and subscribe to MQTT broker
  const _connectMQTT = async props => {
    let now = new Date().valueOf();
    if (!client) {
      let clientID = 'GoldenSparrowCapital-' + Math.random().toString(16).substring(2, 8);
      const gsccookie = Cookies.get('gsccookie') || null;
      const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
        clientId: clientID,
        username: 'user-jwt',
        password: gsccookie,
        clean: true,
        rejectUnauthorized: true,
        reconnectPeriod: 60000,
      });
      mqttClientRef.current = newClient;
      newClient.on('connect', async () => {
        console.log('Connected to MQTT:', new Date().toLocaleTimeString());

        newClient.publish('GET_PRESIGNALS', JSON.stringify({ token: gsccookie }), err => {
          if (!err) {
           // console.log('GET_PRESIGNALS request published:', new Date().toLocaleTimeString());
          } else {
            console.error('Topic Publish error', err);
          }
        });

        newClient.subscribe('RECEIVE_PRESIGNALS', err => {
          if (!err) {
           // console.log('Topic subscribed:RECEIVE_PRESIGNALS');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });
      });

      setClient(newClient);
    }
  };
  useEffect(() => {
    async function fetchData() {
      if (client) {
        client.on('message', (topic, message) => {
          console.log('Received topic:', topic, new Date().toLocaleTimeString());
          if (topic == 'RECEIVE_PRESIGNALS') {
            let raw = JSON.parse(message);
           // console.log("Raw:", raw)
            setPreSignals(raw.preSignals);
            setLastUpdated(new Date().valueOf());
          }
        });
      }
    }
    fetchData();
    return () => {
      if (client) {
        if (mqttClientRef.current) {
          console.log('Disconnecting...', new Date().toLocaleTimeString());
          mqttClientRef.current.end(); // Disconnect properly
          setClient(null);
        }
      }
    };
  }, [client]);

  useEffect(() => {
    async function fetchData() {
      await _connectMQTT(props);
    }
    fetchData();
  }, []);



  return preSignals ? (
    <div style={{ borderRadius: 8, width: 'auto' }}>
      <PreSignalPopup
        preSignal={popupPreSignal}
        onClose={() => {
          setPopupPreSignal(null);
        }}
        // onUpdatePreSignal={updatedPreSignal => {
        //   setPopupPreSignal(updatedPreSignal);
        //   setPreSignals(arr => arr.map(obj => (obj.uuid === updatedPreSignal.uuid ? updatedPreSignal : obj)));
        // }}
        transitionPreSignalToWatcher={object => {
         
          const gsccookie = Cookies.get('gsccookie') || null;
          client.publish('TRANSITION_PRESIGNAL_TO_WATCHER', JSON.stringify({ token: gsccookie, preSignal: object.preSignal, limitPrice: object.limitPrice, stopLossPrice: object.stopLossPrice, currentPrice: object.symbolCurrentPrice }), err => {
            if (!err) {
              setPopupPreSignal(null);
            } else {
              console.error('TRANSITION_PRESIGNAL_TO_WATCHER Error:', err);
             alert("Error: Transitioning to Watcher")
            }
          });
        }}
      />
      {/* <h6 style={{ margin: 3, textAlign : "right", fontSize : 12 }}>Count: {watchers.length}</h6> */}
      {/* <h1 className="text-sm font-normal">{props.user.email + ',' + props.user.userType}</h1> */}
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray', marginBottom: 3 }}>
        {' '}
        Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
        {new Date(lastUpdated).toLocaleTimeString()}
      </h1>

      {/* Strategy201 */}

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2" style={{marginBottom : 10}}>
        <h1 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          Strategy201 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy201").length})
        </h1>

         {/* Stage1 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage1 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy201" && preSignal?.preSignalStatus?.stage == "STAGE1").length})
        </h3>
        {preSignals.filter(preSignal => preSignal.strategyName === "Strategy201" && preSignal?.preSignalStatus?.stage == "STAGE1").length > 0 ? (
          <div style={{ padding: 5 }}>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy201" &&
                    preSignal?.preSignalStatus?.stage == "STAGE1"
                  ),
                  'preSignalStatus.lastUpdated',
                  'desc'
                ).map((preSignal, index) => {
                  return (
                     <button
                     key={index}
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                            margin : 2
                          }}
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol} ({new Date(preSignal.creationDate).toLocaleDateString()} {new Date(preSignal.creationDate).toLocaleTimeString()})</h4>
                           </div>
                        </button>
                      );
                    })}
          </div>
        ) : (
         null
        )}
      </div>

      {/* Strategy22 */}
   
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2" style={{marginBottom : 10}}>
        <h1 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          Strategy22 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy22").length})
        </h1>

         {/* Stage1 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage1 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy22" && preSignal?.preSignalStatus?.stage == "STAGE1").length})
        </h3>
         {preSignals.filter(preSignal => preSignal.strategyName === "Strategy22" && preSignal?.preSignalStatus?.stage == "STAGE1").length > 0 ? (
          <div style={{ padding: 5 }}>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy22" &&
                    preSignal?.preSignalStatus?.stage == "STAGE1"
                  ),
                  'preSignalStatus.lastUpdated',
                  'desc'
                ).map((preSignal, index) => {
                  return (
                     <button
                     key={index}
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                            margin : 2
                          }}
                          // target="_blank"
                          // variant="contained"
                          // endIcon={<OpenInNewIcon fontSize="small" />}
                          // size="small"
                          // href={
                          //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                          //   watcher.symbol
                          // }
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol} ({new Date(preSignal.creationDate).toLocaleDateString()} {new Date(preSignal.creationDate).toLocaleTimeString()})</h4>
                           </div>
                        </button>
                      );
                    })}
          </div>
        ) : (
         null
        )}

          <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage2 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy22" && preSignal?.preSignalStatus?.stage == "STAGE2").length})
        </h3>
         {preSignals.filter(preSignal => preSignal.strategyName === "Strategy22" && preSignal?.preSignalStatus?.stage == "STAGE2").length > 0 ? (
          <div style={{ padding: 5 }}>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy22" &&
                    preSignal?.preSignalStatus?.stage == "STAGE2"
                  ),
                  'preSignalStatus.lastUpdated',
                  'desc'
                ).map((preSignal, index) => {
                  return (
                    <button
                     key={index}
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                             margin : 2
                          }}
                          // target="_blank"
                          // variant="contained"
                          // endIcon={<OpenInNewIcon fontSize="small" />}
                          // size="small"
                          // href={
                          //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                          //   watcher.symbol
                          // }
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol}</h4>
                           </div>
                        </button>
                        );
                })}
          
          </div>
        ) : (
         null
        )}
       </div>

{/* Strategy21 */}
   
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2" style={{marginBottom : 10}}>
        <h1 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          Strategy21 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy21").length})
        </h1>

        {/* Stage1 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage1 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy21" && preSignal?.preSignalStatus?.stage == "STAGE1").length})
        </h3>

        {preSignals.filter(preSignal => preSignal.strategyName === "Strategy21" && preSignal?.preSignalStatus?.stage == "STAGE1").length > 0 ? (
          <div style={{ padding: 5 }}>
            <table className="min-w-full shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Strategy</th>
                  <th className="text-sm py-2 px-4 border-b">Previous Stage</th>
                  <th className="text-sm py-2 px-4 border-b">Market Order</th>
                  <th className="text-sm py-2 px-4 border-b">FVG Low</th>
                  <th className="text-sm py-2 px-4 border-b">FVG High</th>
                  <th className="text-sm py-2 px-4 border-b">Save</th>
                   <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy21" &&
                    preSignal?.preSignalStatus?.stage == "STAGE1"
                  ),
                  'preSignalStatus.lastUpdated',
                  'desc'
                ).map((preSignal, index) => {
                  return (
                    <tr key={preSignal.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                      </td>
                      {/* Date & Time */}
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {new Date(preSignal.creationDate).toLocaleDateString() +
                          ', ' +
                          new Date(preSignal.creationDate).toLocaleTimeString(undefined, {
                            hour12: true,
                          })}
                      </td>
                      {/* Symbol */}
                      <td className="py-2 px-4 border-b">
                        <button
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          // target="_blank"
                          // variant="contained"
                          // endIcon={<OpenInNewIcon fontSize="small" />}
                          // size="small"
                          // href={
                          //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                          //   watcher.symbol
                          // }
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol}</h4>
                            <h6 style={{ paddingLeft: 5 }}>{new Date(preSignal.preSignalStatus.lastUpdated).toLocaleDateString() +
                              ', ' +
                              new Date(preSignal.preSignalStatus.lastUpdated).toLocaleTimeString(undefined, {
                                hour12: true,
                              })}
                            </h6>
                            {/* <h6 style={{ paddingLeft: 5 }}>${preSignal.currentPrice}</h6> */}
                          </div>
                        </button>
                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.strategyName}</td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.preSignalStatus.previousStage}</td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.marketOrder}</td>
                     <td className="text-xs py-2 px-4 border-b text-center">
                       <input
                         id={`fvgLow-${preSignal.uuid}`}
                         name="fvgLow"
                         type="text"
                         required
                         placeholder="FVG Low"
                         value={
                           fvgLow[preSignal.uuid] !== undefined
                             ? fvgLow[preSignal.uuid]
                             : (preSignal.preSignalStatus && preSignal.preSignalStatus.fvgLow !== undefined
                                 ? preSignal.preSignalStatus.fvgLow
                                 : '')
                         }
                         onChange={e => {
                           const value = e.target.value;
                           setFvgLow(prev => ({
                             ...prev,
                             [preSignal.uuid]: value !== '' ? value : (preSignal.preSignalStatus && preSignal.preSignalStatus.fvgLow !== undefined ? preSignal.preSignalStatus.fvgLow : '')
                           }));
                         }} style={{ padding: 5, borderRadius: 5, color: "black" }}
                       />
                     </td>
                     <td className="text-xs py-2 px-4 border-b text-center">
                       <input
                         id={`fvgHigh-${preSignal.uuid}`}
                         name="fvgHigh"
                         type="text"
                         autoComplete="current-password"
                         required
                         placeholder="FVG High"
                         value={
                           fvgHigh[preSignal.uuid] !== undefined
                             ? fvgHigh[preSignal.uuid]
                             : (preSignal.preSignalStatus && preSignal.preSignalStatus.fvgHigh !== undefined
                                 ? preSignal.preSignalStatus.fvgHigh
                                 : '')
                         }
                         onChange={e => {
                           const value = e.target.value;
                           setFvgHigh(prev => ({
                             ...prev,
                             [preSignal.uuid]: value !== '' ? value : (preSignal.preSignalStatus && preSignal.preSignalStatus.fvgHigh !== undefined ? preSignal.preSignalStatus.fvgHigh : '')
                           }));
                         }}
                         style={{ padding: 5, borderRadius: 5, color: "black" }}
                       />
                     </td>
                      <td className="py-2 px-4 border-b text-center">
                        <button
                          style={{
                            backgroundColor: 'red',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          onClick={() => {
                            const gsccookie = Cookies.get('gsccookie') || null;
                            client.publish('UPDATE_PRESIGNAL_Strategy_EMA200', JSON.stringify({
                              token: gsccookie,
                              preSignal,
                              fvgLow: fvgLow[preSignal.uuid] || '',
                              fvgHigh: fvgHigh[preSignal.uuid] || '',
                              nextStage: "STAGE2"
                            }), err => {
                              if (!err) {
                                console.log('UPDATE_PRESIGNAL published:', new Date().toLocaleTimeString());
                              } else {
                                console.error('UPDATE_PRESIGNAL:', err);
                              }
                            });
                          }}
                        >
                          Save
                        </button>

                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <button style={{ justifyContent: "center" }}
                          onClick={() => {
                            // const confirmAction = window.confirm("Are you sure you want to proceed with this deletion?");
                            // if (confirmAction) {
                            const gsccookie1 = Cookies.get('gsccookie') || null;
                            client.publish('DELETE_PRESIGNAL', JSON.stringify({ token: gsccookie1, preSignal }), err => {
                              if (!err) {
                                console.log('DELETE_PRESIGNAL published:', new Date().toLocaleTimeString());
                              } else {
                                console.error('DELETE_PRESIGNAL:', err);
                              }
                            });

                            // }
                          }}
                        >
                          <svg
                            className="w-5 h-5 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: 5 }}>
            <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals yet.</h5>
          </div>
        )}
        </div>




{/* Strategy-EMA200-HIT */}
   
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2" style={{marginBottom : 10}}>
        <h1 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", }}>
          Strategy-EMA200-HIT ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT").length})
        </h1>

        {/* Stage1 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage1 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE1").length})
        </h3>
      
        {preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE1").length > 0 ? (
          <div style={{ padding: 5 }}>
            <table className="min-w-full shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Strategy</th>
                  <th className="text-sm py-2 px-4 border-b">Previous Stage</th>
                  <th className="text-sm py-2 px-4 border-b">Market Order</th>
                  <th className="text-sm py-2 px-4 border-b">FVG Low</th>
                  <th className="text-sm py-2 px-4 border-b">FVG High</th>
                  <th className="text-sm py-2 px-4 border-b">Save</th>
                   <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" &&
                    preSignal?.preSignalStatus?.stage == "STAGE1"
                  ),
                  'preSignalStatus.lastUpdated',
                  'desc'
                ).map((preSignal, index) => {
                  return (
                    <tr key={preSignal.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                      </td>
                      {/* Date & Time */}
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {new Date(preSignal.creationDate).toLocaleDateString() +
                          ', ' +
                          new Date(preSignal.creationDate).toLocaleTimeString(undefined, {
                            hour12: true,
                          })}
                      </td>
                      {/* Symbol */}
                      <td className="py-2 px-4 border-b">
                        <button
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          // target="_blank"
                          // variant="contained"
                          // endIcon={<OpenInNewIcon fontSize="small" />}
                          // size="small"
                          // href={
                          //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                          //   watcher.symbol
                          // }
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol}</h4>
                            <h6 style={{ paddingLeft: 5 }}>{new Date(preSignal.preSignalStatus.lastUpdated).toLocaleDateString() +
                              ', ' +
                              new Date(preSignal.preSignalStatus.lastUpdated).toLocaleTimeString(undefined, {
                                hour12: true,
                              })}
                            </h6>
                            {/* <h6 style={{ paddingLeft: 5 }}>${preSignal.currentPrice}</h6> */}
                          </div>
                        </button>
                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.strategyName}</td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.preSignalStatus.previousStage}</td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.marketOrder}</td>
                     <td className="text-xs py-2 px-4 border-b text-center">
                       <input
                         id={`fvgLow-${preSignal.uuid}`}
                         name="fvgLow"
                         type="text"
                         required
                         placeholder="FVG Low"
                         value={
                           fvgLow[preSignal.uuid] !== undefined
                             ? fvgLow[preSignal.uuid]
                             : (preSignal.preSignalStatus && preSignal.preSignalStatus.fvgLow !== undefined
                                 ? preSignal.preSignalStatus.fvgLow
                                 : '')
                         }
                         onChange={e => {
                           const value = e.target.value;
                           setFvgLow(prev => ({
                             ...prev,
                             [preSignal.uuid]: value !== '' ? value : (preSignal.preSignalStatus && preSignal.preSignalStatus.fvgLow !== undefined ? preSignal.preSignalStatus.fvgLow : '')
                           }));
                         }} style={{ padding: 5, borderRadius: 5, color: "black" }}
                       />
                     </td>
                     <td className="text-xs py-2 px-4 border-b text-center">
                       <input
                         id={`fvgHigh-${preSignal.uuid}`}
                         name="fvgHigh"
                         type="text"
                         autoComplete="current-password"
                         required
                         placeholder="FVG High"
                         value={
                           fvgHigh[preSignal.uuid] !== undefined
                             ? fvgHigh[preSignal.uuid]
                             : (preSignal.preSignalStatus && preSignal.preSignalStatus.fvgHigh !== undefined
                                 ? preSignal.preSignalStatus.fvgHigh
                                 : '')
                         }
                         onChange={e => {
                           const value = e.target.value;
                           setFvgHigh(prev => ({
                             ...prev,
                             [preSignal.uuid]: value !== '' ? value : (preSignal.preSignalStatus && preSignal.preSignalStatus.fvgHigh !== undefined ? preSignal.preSignalStatus.fvgHigh : '')
                           }));
                         }}
                         style={{ padding: 5, borderRadius: 5, color: "black" }}
                       />
                     </td>
                      <td className="py-2 px-4 border-b text-center">
                        <button
                          style={{
                            backgroundColor: 'red',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          onClick={() => {
                            const gsccookie = Cookies.get('gsccookie') || null;
                            client.publish('UPDATE_PRESIGNAL_Strategy_EMA200', JSON.stringify({
                              token: gsccookie,
                              preSignal,
                              fvgLow: fvgLow[preSignal.uuid] || '',
                              fvgHigh: fvgHigh[preSignal.uuid] || '',
                              nextStage: "STAGE2"
                            }), err => {
                              if (!err) {
                                console.log('UPDATE_PRESIGNAL published:', new Date().toLocaleTimeString());
                              } else {
                                console.error('UPDATE_PRESIGNAL:', err);
                              }
                            });
                          }}
                        >
                          Save
                        </button>

                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <button style={{ justifyContent: "center" }}
                          onClick={() => {
                            // const confirmAction = window.confirm("Are you sure you want to proceed with this deletion?");
                            // if (confirmAction) {
                            const gsccookie1 = Cookies.get('gsccookie') || null;
                            client.publish('DELETE_PRESIGNAL', JSON.stringify({ token: gsccookie1, preSignal }), err => {
                              if (!err) {
                                console.log('DELETE_PRESIGNAL published:', new Date().toLocaleTimeString());
                              } else {
                                console.error('DELETE_PRESIGNAL:', err);
                              }
                            });

                            // }
                          }}
                        >
                          <svg
                            className="w-5 h-5 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: 5 }}>
            <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals yet.</h5>
          </div>
        )}

         {/* Stage2 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage2 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE2").length})
        </h3>
         {preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE2").length > 0 ? (
          <div style={{ padding: 5 }}>
         
            
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" &&
                    preSignal?.preSignalStatus?.stage == "STAGE2"
                  ),
                  'preSignalStatus.lastUpdated',
                  'desc'
                ).map((preSignal, index) => {
                  return (
                    <span key={index} style={{color : "grey"}}>{preSignal.symbol},</span>
                  );
                })}
          
          </div>
        ) : (
         null
        )}

         {/* Stage3 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage3 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE3").length})
        </h3>
         {preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE3").length > 0 ? (
          <div style={{ padding: 5 }}>
         
            
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" &&
                    preSignal?.preSignalStatus?.stage == "STAGE3"
                  ),
                  'preSignalStatus.lastUpdated',
                  'desc'
                ).map((preSignal, index) => {
                  return (
                    <span key={index} style={{color : "grey"}}>{preSignal.symbol},</span>
                  );
                })}
          
          </div>
        ) : (
         null
        )}
    

         {/* Stage4 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage4 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE4").length})
        </h3>
         {preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE4").length > 0 ? (
          <div style={{ padding: 5 }}>
         
            
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" &&
                    preSignal?.preSignalStatus?.stage == "STAGE4"
                  ),
                  'preSignalStatus.lastUpdated',
                  'desc'
                ).map((preSignal, index) => {
                  return (
                   <span key={index} style={{color : "grey"}}>{preSignal.symbol},</span>
                  );
                })}
          
          </div>
        ) : (
         null
        )}
       

          {/* Stage5 */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage5 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-EMA200-HIT" && preSignal?.preSignalStatus?.stage == "STAGE5").length})
        </h3>
       </div>
  

{/* Strategy-FVG-180 */}
 <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2" style={{marginBottom : 10}}>
       <h1 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Strategy-FVG-180 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE3A").length})
        </h1>
   
      
 {/* Stage3A */}
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage3A
        
        </h3>
     
        {preSignals.filter(preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE3A").length > 0 ? (
          <div style={{ padding: 5 }}>
            <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Strategy</th>
                  <th className="text-sm py-2 px-4 border-b">Previous Stage</th>
                  <th className="text-sm py-2 px-4 border-b">Market Order</th>
                  <th className="text-sm py-2 px-4 border-b">Open</th>
                   <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE3A"
                  ),
                  'preSignalStatus.lastUpdated',
                  'asc'
                ).map((preSignal, index) => {
                  return (
                    <tr key={preSignal.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                      </td>
                      {/* Date & Time */}
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {new Date(preSignal.creationDate).toLocaleDateString() +
                          ', ' +
                          new Date(preSignal.creationDate).toLocaleTimeString(undefined, {
                            hour12: true,
                          })}
                      </td>
                      {/* Symbol */}
                      <td className="py-2 px-4 border-b">
                        <button
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          // target="_blank"
                          // variant="contained"
                          // endIcon={<OpenInNewIcon fontSize="small" />}
                          // size="small"
                          // href={
                          //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                          //   watcher.symbol
                          // }
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol}</h4>
                            <h6 style={{ paddingLeft: 5 }}>{new Date(preSignal.preSignalStatus.lastUpdated).toLocaleDateString() +
                              ', ' +
                              new Date(preSignal.preSignalStatus.lastUpdated).toLocaleTimeString(undefined, {
                                hour12: true,
                              })}
                            </h6>
                            {/* <h6 style={{ paddingLeft: 5 }}>${preSignal.currentPrice}</h6> */}
                          </div>
                        </button>
                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.strategyName}</td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.preSignalStatus.previousStage}</td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.marketOrder}</td>
                      <td className="py-2 px-4 border-b text-center">
                        <button
                          style={{
                            backgroundColor: 'red',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          onClick={() => setPopupPreSignal(preSignal)}
                        >
                          Open
                        </button>

                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <button style={{ justifyContent: "center" }}
                          onClick={() => {
                            // const confirmAction = window.confirm("Are you sure you want to proceed with this deletion?");
                            // if (confirmAction) {
                            const gsccookie1 = Cookies.get('gsccookie') || null;
                           client.publish('DELETE_PRESIGNAL', JSON.stringify({ token: gsccookie1, preSignal }), err => {
                               if (!err) {
                                console.log('DELETE_PRESIGNAL published:', new Date().toLocaleTimeString());
                              } else {
                                console.error('DELETE_PRESIGNAL:', err);
                              }
                            });

                            // }
                          }}
                        >
                          <svg
                            className="w-5 h-5 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: 5 }}>
            <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals yet.</h5>
          </div>
        )}
      

      {/* Stage 3 */}
 
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage3 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE3").length})
        </h3>

       
        {preSignals.filter(preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE3").length > 0 ? (
          <div style={{ padding: 5 }}>
            <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Strategy</th>
                  <th className="text-sm py-2 px-4 border-b">Stage</th>
                  <th className="text-sm py-2 px-4 border-b">Market Order</th>
                  <th className="text-sm py-2 px-4 border-b">Open</th>
                  <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE3"
                  ),
                  'preSignalStatus.lastUpdated',
                  'asc'
                ).map((preSignal, index) => {
                  return (
                    <tr key={preSignal.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                      </td>
                      {/* Date & Time */}
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {new Date(preSignal.creationDate).toLocaleDateString() +
                          ', ' +
                          new Date(preSignal.creationDate).toLocaleTimeString(undefined, {
                            hour12: true,
                          })}
                      </td>
                      {/* Symbol */}
                      <td className="py-2 px-4 border-b">
                        <button
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          // target="_blank"
                          // variant="contained"
                          // endIcon={<OpenInNewIcon fontSize="small" />}
                          // size="small"
                          // href={
                          //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                          //   watcher.symbol
                          // }
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol}</h4>
                            <h6 style={{ paddingLeft: 5 }}>{new Date(preSignal.preSignalStatus.lastUpdated).toLocaleDateString() +
                              ', ' +
                              new Date(preSignal.preSignalStatus.lastUpdated).toLocaleTimeString(undefined, {
                                hour12: true,
                              })}
                            </h6>
                            {/* <h6 style={{ paddingLeft: 5 }}>${preSignal.currentPrice}</h6> */}
                          </div>
                        </button>
                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.strategyName}</td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.preSignalStatus.stage}</td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.marketOrder}</td>
                      <td className="py-2 px-4 border-b text-center">
                        <button
                          style={{
                            backgroundColor: 'red',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          onClick={() => setPopupPreSignal(preSignal)}
                        >
                          Open
                        </button>

                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <button style={{ justifyContent: "center" }}
                          onClick={() => {
                            // const confirmAction = window.confirm("Are you sure you want to proceed with this deletion?");
                            // if (confirmAction) {
                            const gsccookie1 = Cookies.get('gsccookie') || null;
                           client.publish('DELETE_PRESIGNAL', JSON.stringify({ token: gsccookie1, preSignal }), err => {
                               if (!err) {
                                console.log('DELETE_PRESIGNAL published:', new Date().toLocaleTimeString());
                              } else {
                                console.error('DELETE_PRESIGNAL:', err);
                              }
                            });

                            // }
                          }}
                        >
                          <svg
                            className="w-5 h-5 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: 5 }}>
            <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No STAGE3 signals yet.</h5>
          </div>
        )}
      


      {/* //Stage2 */}
   
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage2 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE2").length})
        </h3>

    
        {preSignals.filter(preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE2").length > 0 ? (

          <div style={{ padding: 5 }}>
            <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Strategy</th>
                  <th className="text-sm py-2 px-4 border-b">Market Order</th>
                  <th className="text-sm py-2 px-4 border-b">Prices (Lowest, fvgLow, fvgHigh)</th>
                  <th className="text-sm py-2 px-4 border-b">Break Price & Hit</th>
                  <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE2"
                  ),
                  'preSignalStatus.lastUpdated',
                  'asc'
                ).map((preSignal, index) => {
                  return (
                    <tr key={preSignal.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                      </td>
                      {/* Date & Time */}
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {new Date(preSignal.creationDate).toLocaleDateString() +
                          ', ' +
                          new Date(preSignal.creationDate).toLocaleTimeString(undefined, {
                            hour12: true,
                          })}
                      </td>
                      {/* Symbol */}
                      <td className="py-2 px-4 border-b">
                        <button
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          // target="_blank"
                          // variant="contained"
                          // endIcon={<OpenInNewIcon fontSize="small" />}
                          // size="small"
                          // href={
                          //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                          //   watcher.symbol
                          // }
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol}</h4>
                            <h6 style={{ paddingLeft: 5 }}>{new Date(preSignal.preSignalStatus.lastUpdated).toLocaleDateString() +
                              ', ' +
                              new Date(preSignal.preSignalStatus.lastUpdated).toLocaleTimeString(undefined, {
                                hour12: true,
                              })}
                            </h6>
                            {/* <h6 style={{ paddingLeft: 5 }}>${preSignal.currentPrice}</h6> */}
                          </div>
                        </button>
                      </td>
                      {/* Strategy */}
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.strategyName}</td>
{/* Market Order */}
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.marketOrder}</td>
                     {/* Prices (Lowest, fvgLow, fvgHigh) */}
                      <td className="text-xs py-2 px-4 border-b text-center">{Number(preSignal.preSignalStatus.lowestPrice)},{Number(preSignal.preSignalStatus.fvgLow)},{Number(preSignal.preSignalStatus.fvgHigh)}</td>
                      {/* Break Price */}
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {Number(preSignal.preSignalStatus.breakPrice).toFixed(preSignal.numberOfDecimalValues)}
                        {preSignal.preSignalStatus.breakPriceHit ? (<span>(Yes)</span>) : (<span>(No)</span>)}
                       
                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <button style={{ justifyContent: "center" }}
                          onClick={() => {
                            // const confirmAction = window.confirm("Are you sure you want to proceed with this deletion?");
                            // if (confirmAction) {
                            const gsccookie1 = Cookies.get('gsccookie') || null;
                           client.publish('DELETE_PRESIGNAL', JSON.stringify({ token: gsccookie1, preSignal }), err => {
                               if (!err) {
                                console.log('DELETE_PRESIGNAL published:', new Date().toLocaleTimeString());
                              } else {
                                console.error('DELETE_PRESIGNAL:', err);
                              }
                            });

                            // }
                          }}
                        >
                          <svg
                            className="w-5 h-5 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: 5 }}>
            <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No STAGE2 signals yet.</h5>
          </div>
        )}
     
      {/* //Stage1 */}
   
        <h3 style={{ margin: 0, paddingTop: 1, marginBottom: 3, fontWeight: "bolder", marginTop: 5 }}>
          Stage1 ({preSignals.filter(preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE1").length})
        </h3>

     
        {preSignals.filter(preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE1").length > 0 ? (
          <div style={{ padding: 5 }}>
            <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Strategy</th>
                  <th className="text-sm py-2 px-4 border-b">Market Order</th>
                  {/* <th className="text-sm py-2 px-4 border-b">Open</th>*/}
                  <th className="text-sm py-2 px-4 border-b">Delete</th>
                </tr>
              </thead>
              <tbody>
                {_.orderBy(
                  preSignals.filter(
                    preSignal => preSignal.strategyName === "Strategy-FVG-180" && preSignal?.preSignalStatus?.stage == "STAGE1"
                  ),
                  'lastUpdated',
                  'asc'
                ).map((preSignal, index) => {
                  return (
                    <tr key={preSignal.uuid}>
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                      </td>
                      {/* Date & Time */}
                      <td className="text-xs py-2 px-4 border-b text-center">
                        {new Date(preSignal.creationDate).toLocaleDateString() +
                          ', ' +
                          new Date(preSignal.creationDate).toLocaleTimeString(undefined, {
                            hour12: true,
                          })}
                      </td>
                      {/* Symbol */}
                      <td className="py-2 px-4 border-b">
                        <button
                          style={{
                            backgroundColor: 'grey',
                            fontSize: 12,
                            borderRadius: 5,
                            padding: 5,
                          }}
                          // target="_blank"
                          // variant="contained"
                          // endIcon={<OpenInNewIcon fontSize="small" />}
                          // size="small"
                          // href={
                          //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                          //   watcher.symbol
                          // }
                          onClick={() =>
                            window.open(
                              'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + preSignal.symbol,
                              '_blank'
                            )
                          }
                        >
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{preSignal.symbol}</h4>

                            {/* <h6 style={{ paddingLeft: 5 }}>${preSignal.currentPrice}</h6> */}
                          </div>
                        </button>
                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.strategyName}</td>

                      <td className="text-xs py-2 px-4 border-b text-center">{preSignal.marketOrder}</td>
                      {/* <td className="py-2 px-4 border-b text-center">
                      <button
                        style={{
                          backgroundColor: 'red',
                          fontSize: 12,
                          borderRadius: 5,
                          padding: 5,
                        }}
                        onClick={() => setPopupPreSignal(preSignal)}
                      >
                        Open
                      </button>
                    </td> */}
                      <td className="text-xs py-2 px-4 border-b text-center">
                        <button style={{ justifyContent: "center" }}
                          onClick={() => {
                            // const confirmAction = window.confirm("Are you sure you want to proceed with this deletion?");
                            // if (confirmAction) {
                            const gsccookie1 = Cookies.get('gsccookie') || null;
                           client.publish('DELETE_PRESIGNAL', JSON.stringify({ token: gsccookie1, preSignal }), err => {
                               if (!err) {
                                console.log('DELETE_PRESIGNAL published:', new Date().toLocaleTimeString());
                              } else {
                                console.error('DELETE_PRESIGNAL:', err);
                              }
                            });

                            // }
                          }}
                        >
                          <svg
                            className="w-5 h-5 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ padding: 5 }}>
            <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No STAGE1 signals yet.</h5>
          </div>
        )}
   
      </div>
    </div>
  ) : null;
};

function PreSignalPopup({ preSignal, onClose, transitionPreSignalToWatcher }) {
   const wsRefBinance = useRef(null);
  const [limitPrice, setLimitPrice] = useState(null)
  const [stopLossPrice, setStopLossPrice] = useState(null)
const [symbolCurrentPrice, setSymbolCurrentPrice] = useState(null)
  useEffect(() => {
    if (preSignal && preSignal.currentPrice) {
      setLimitPrice(Number(preSignal.currentPrice).toFixed(preSignal.numberOfDecimalValues));
      setStopLossPrice(Number(preSignal.preSignalStatus.lowestPrice).toFixed(preSignal.numberOfDecimalValues));
      subscribeToSymbols([preSignal.symbol]);
    }
  }, [preSignal]);

    // Function to subscribe to real-time Binance prices
  const subscribeToSymbols = async (symbols) => {
    console.log("Subscribing to Binance prices for:", symbols.length);
    unsubscribeFromSymbols();
    const streams = symbols.map(symbol => `${symbol.toLowerCase()}@ticker`).join('/');
    const url = `wss://stream.binance.com:9443/stream?streams=${streams}`;

    wsRefBinance.current = new WebSocket(url);

    wsRefBinance.current.onmessage = event => {
      const message = JSON.parse(event.data);
      const { s: symbol, c: currentPrice } = message.data;
    //  console.log(`Real-time price update for ${symbol}: ${currentPrice}`);
      setSymbolCurrentPrice(currentPrice)
    };

    wsRefBinance.current.onerror = err => {
      // console.error("Binance WebSocket error:", err);
    };

    wsRefBinance.current.onclose = () => {
      // console.log("Binance WebSocket closed");
    };
  };

  // Function to unsubscribe/cleanup
  const unsubscribeFromSymbols = () => {
    if (wsRefBinance.current) {
      wsRefBinance.current.close();
      wsRefBinance.current = null;
      // console.log('Unsubscribed from Binance prices');
    }
  };

  if (!preSignal) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
      }}
      onClick={onClose}
    >
      <div
        id="preSignal-popoup"
        style={{
          width: '450px',
          backgroundColor: '#fff',
          padding: 24,
          borderRadius: 16,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          paddingRight: 10,
        }}
        onClick={e => e.stopPropagation()}
      >

        {/* 1st row */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8,
          }}
        >
          <h1 style={{ color: "blue", fontWeight: "bold" }}>{preSignal.symbol}
            ({Number(symbolCurrentPrice).toFixed(preSignal.numberOfDecimalValues)})
          </h1>
          <button
            style={{
              padding: '4px',
              borderWidth: 1,
              borderColor: "red",
              color: 'red',
              borderRadius: 6,
              fontSize: 11,
              cursor: 'pointer',
            }}
            onClick={() => {
              unsubscribeFromSymbols()
              onClose()
            }}
          >
            Close
          </button>
        </div>
        <hr></hr>

        {symbolCurrentPrice ? 
<>
        {/* 2nd Row */}
        <div
          style={{
            display: 'flex',
            // justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8,
            marginTop: 30,
            gap: 20
          }}
        >
          <h1 style={{ color: '#282828', fontWeight: "bold", fontStyle: "italic", fontSize: 13 }}>Set Limit Price:</h1>
          <button
            style={{
              padding: 3,
              backgroundColor: 'red',
              color: '#fff',
              borderRadius: 50,
              fontSize: 18,
              cursor: 'pointer',
              width: 35,
              height: 35
            }}
            onClick={() => {

               let ll = limitPrice
              setLimitPrice(Number(Number(ll).toFixed(preSignal.numberOfDecimalValues) - (1 / Math.pow(10, preSignal.numberOfDecimalValues))).toFixed(preSignal.numberOfDecimalValues))

              let sl = stopLossPrice
              if (Number(sl) >= Number(limitPrice)) {
                setStopLossPrice(Number(Number(ll).toFixed(preSignal.numberOfDecimalValues) - (2 / Math.pow(10, preSignal.numberOfDecimalValues))).toFixed(preSignal.numberOfDecimalValues))
              }

            }}
          >
            -
          </button>
          <h1 style={{ color: '#282828', fontWeight: 'bold' }}>{limitPrice}</h1>

          <button
            style={{
              padding: 3,
              backgroundColor: 'green',
              color: '#fff',
              borderRadius: 50,
              fontSize: 18,
              cursor: 'pointer',
              width: 35,
              height: 35

            }}
            onClick={() => {
            
                let ll = limitPrice
                 setLimitPrice(Number(Number(ll).toFixed(preSignal.numberOfDecimalValues) + (1 / Math.pow(10, preSignal.numberOfDecimalValues))).toFixed(preSignal.numberOfDecimalValues))
              }}
          >
            +
          </button>





        </div>

        {/* 3rd Row */}
        <div
          style={{
            display: 'flex',
            // justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8,
            marginTop: 30,
            gap: 20
          }}
        >
          <h1 style={{ color: '#282828', fontWeight: "bold", fontStyle: "italic", fontSize: 13 }}>Set Stop Loss Price:</h1>
          <button
            style={{
              padding: 3,
              backgroundColor: 'red',
              color: '#fff',
              borderRadius: 50,
              fontSize: 18,
              cursor: 'pointer',
              width: 35,
              height: 35
            }}
            onClick={() => {
               let ll = stopLossPrice
              setStopLossPrice(Number(Number(ll).toFixed(preSignal.numberOfDecimalValues) - (1 / Math.pow(10, preSignal.numberOfDecimalValues))).toFixed(preSignal.numberOfDecimalValues))
               }}
          >
            -
          </button>
          <h1 style={{ color: '#282828', fontWeight: 'bold' }}>{stopLossPrice}</h1>

          <button
            style={{
              padding: 3,
              backgroundColor: 'green',
              color: '#fff',
              borderRadius: 50,
              fontSize: 18,
              cursor: 'pointer',
              width: 35,
              height: 35

            }}
            onClick={() => {
              let ll = stopLossPrice
              setStopLossPrice(Number(Number(ll).toFixed(preSignal.numberOfDecimalValues) + (1 / Math.pow(10, preSignal.numberOfDecimalValues))).toFixed(preSignal.numberOfDecimalValues))
            }}
          >
            +
          </button>
        </div>

        {/* 4th row */}
        <div
          style={{
            display: 'flex',
            marginBottom: 8,
            justifyContent: "center",
            columnGap: 5
          }}
        >
          <button
            style={{
              padding: '5px',
              borderWidth: 1,
              borderColor: "blue",
              color: 'blue',
              borderRadius: 6,

              cursor: 'pointer',
              marginTop: 30,
              fontSize: 14,


            }}
            onClick={() => {
              transitionPreSignalToWatcher({ preSignal, limitPrice, stopLossPrice, symbolCurrentPrice })
            }}
          >
            Add to Watcher
          </button>
          

        </div>
        </>
        : null }
      </div>
    </div>
  );
}

export default PreSignalsComponent;
